import _asyncToGenerator from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import qs from 'qs';
import { api } from '.';
import { handleRequestError } from '../utils/request';
export var apiGetCountries = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var _ref$limit, limit, offset, res, _err$response$data$de, _err$response, _err$response$data, _err$response$data$de2, _err$response$data$de3, message;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref$limit = _ref.limit, limit = _ref$limit === void 0 ? 300 : _ref$limit, offset = _ref.offset;
            _context.prev = 1;
            _context.next = 4;
            return api.get("/country", {
              params: {
                limit: limit,
                offset: offset,
                order_by: 'name'
              }
            });

          case 4:
            res = _context.sent;
            return _context.abrupt("return", [res.data]);

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            message = (_err$response$data$de = (_err$response = _context.t0.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : (_err$response$data$de2 = _err$response$data.detail) === null || _err$response$data$de2 === void 0 ? void 0 : (_err$response$data$de3 = _err$response$data$de2[0]) === null || _err$response$data$de3 === void 0 ? void 0 : _err$response$data$de3.msg) !== null && _err$response$data$de !== void 0 ? _err$response$data$de : _context.t0;
            console.error("Failed to retrieve countries: ".concat(message));
            return _context.abrupt("return", [null, _context.t0]);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 8]]);
  }));

  return function apiGetCountries(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export var apiGetAvailableCountriesForOrganization = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(organizationId, config) {
    var res, _err$response$data$de4, _err$response2, _err$response2$data, _err$response2$data$d, _err$response2$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;

            if (organizationId) {
              _context2.next = 3;
              break;
            }

            throw new Error("Invalid organization id: ".concat(organizationId));

          case 3:
            _context2.next = 5;
            return api.get("/organization_region/unused_country", {
              params: {
                organization_id: organizationId,
                candidate_type: config === null || config === void 0 ? void 0 : config.candidateType
              }
            });

          case 5:
            res = _context2.sent;
            return _context2.abrupt("return", [res.data]);

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](0);
            message = (_err$response$data$de4 = (_err$response2 = _context2.t0.response) === null || _err$response2 === void 0 ? void 0 : (_err$response2$data = _err$response2.data) === null || _err$response2$data === void 0 ? void 0 : (_err$response2$data$d = _err$response2$data.detail) === null || _err$response2$data$d === void 0 ? void 0 : (_err$response2$data$d2 = _err$response2$data$d[0]) === null || _err$response2$data$d2 === void 0 ? void 0 : _err$response2$data$d2.msg) !== null && _err$response$data$de4 !== void 0 ? _err$response$data$de4 : _context2.t0;
            console.error("Failed to retrieve countries: ".concat(message));
            return _context2.abrupt("return", [null, _context2.t0]);

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 9]]);
  }));

  return function apiGetAvailableCountriesForOrganization(_x2, _x3) {
    return _ref3.apply(this, arguments);
  };
}();
export var apiGetCurrencies = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref4) {
    var _ref4$limit, limit, offset, res, _err$response$data$de5, _err$response3, _err$response3$data, _err$response3$data$d, _err$response3$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _ref4$limit = _ref4.limit, limit = _ref4$limit === void 0 ? 300 : _ref4$limit, offset = _ref4.offset;
            _context3.prev = 1;
            _context3.next = 4;
            return api.get("currency", {
              params: {
                limit: limit,
                offset: offset,
                order_by: 'name'
              }
            });

          case 4:
            res = _context3.sent;
            return _context3.abrupt("return", [res.data]);

          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](1);
            message = (_err$response$data$de5 = (_err$response3 = _context3.t0.response) === null || _err$response3 === void 0 ? void 0 : (_err$response3$data = _err$response3.data) === null || _err$response3$data === void 0 ? void 0 : (_err$response3$data$d = _err$response3$data.detail) === null || _err$response3$data$d === void 0 ? void 0 : (_err$response3$data$d2 = _err$response3$data$d[0]) === null || _err$response3$data$d2 === void 0 ? void 0 : _err$response3$data$d2.msg) !== null && _err$response$data$de5 !== void 0 ? _err$response$data$de5 : _context3.t0;
            console.error("Failed to retrieve currencies: ".concat(message));
            return _context3.abrupt("return", [null, _context3.t0]);

          case 13:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[1, 8]]);
  }));

  return function apiGetCurrencies(_x4) {
    return _ref5.apply(this, arguments);
  };
}();
export var apiGetAvailableCountriesForOrganizationCompany = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return api.get("/organization_region/unused_country_within_company?".concat(qs.stringify(payload)));

          case 3:
            res = _context4.sent;
            return _context4.abrupt("return", [res.data]);

          case 7:
            _context4.prev = 7;
            _context4.t0 = _context4["catch"](0);
            return _context4.abrupt("return", handleRequestError(_context4.t0, payload));

          case 10:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 7]]);
  }));

  return function apiGetAvailableCountriesForOrganizationCompany(_x5) {
    return _ref6.apply(this, arguments);
  };
}();